import { useCallback, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { STATUS } from "../../constants/avatar";
import { AppConstant } from "../../redux/reducers";
import MButton from "../commons/MButton";

const UnlinkAvatarCollapse = ({ avatarStatus }) => {
    const [t] = useTranslation();
    const deleteable = useMemo(() => [STATUS.SYNCED, STATUS.CONFIRMED].includes(avatarStatus), [avatarStatus]);
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();

    const handlerClickDelete = useCallback(() => {
        setShowModal(true);
    }, []);

    const handlerClickConfirm = useCallback(() => {
        setShowModal(false);
        dispatch({ type: AppConstant.SET_CLEAR_ALL_SHOW });
        dispatch({ type: AppConstant.SET_SHOW_UNLINK, show: true });
    }, [dispatch]);

    return <>
        {deleteable && <>
            <div
                className={`bg-white rounded border border-content_body`}
                style={{ transition: "all 0.2s" }}
            >
                <div
                    className="d-flex align-items-center justify-content-between p-3 cursor-pointer user-select-none"
                    onClick={handlerClickDelete}
                >
                    <div className="text-danger">
                        {t("Delete All Items")}
                    </div>
                </div>
            </div>
        </>}
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered={true}
        >
            <Modal.Header closeButton={true}>
                <Modal.Title className="fs-5 fw-bolder mb-0">
                    {t("Delete All Items")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column gap-3">
                    <div className="py-2">
                        {t("Are you sure you want to delete? Erased data cannot be recovered.")}
                    </div>
                    <div>
                        <MButton
                            color="danger"
                            css="text-white w-100"
                            circle={true}
                            height={56}
                            onClick={handlerClickConfirm}
                        >
                            <div style={{ fontSize: 17 }}>
                                {t("Confirm")}
                            </div>
                        </MButton>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </>
};

const mapState = (state) => {
    const avatarStatus = state.AvatarReducer.status;
    return { avatarStatus };
};

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(UnlinkAvatarCollapse);